<footer class="row footer border-top">
  <div class="col-11 col-lg-9 no-padding">
    <ng-content select="[footer-content]"></ng-content>
    <div [class.hideFooterItems]="isOpen">
      <ng-content select="[footer-items]"></ng-content>
    </div>
  </div>
  <div class="col-1 col-lg-3 no-padding">
    <div class="d-none d-lg-block pl-0">
      <div class="blue-area">
        @if (additionalInfo || beInfos || uiInfos) {
          <tur-additional-info-area
            [beInfos]="beInfos"
            [uiInfos]="uiInfos"
            [additionalInfo]="additionalInfo"></tur-additional-info-area>
        }
      </div>
    </div>
    <div class="d-block d-lg-none d-xl-none pl-sm"></div>
  </div>
</footer>
